import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { Link } from 'react-router-dom';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import "../index.css"
import { getFullName, numberConversion, round } from "../../../../utils";

import { getPMCompanyConfig } from "../../../../setup/pmCompanyConfig";
import { DATE_FORMAT } from "../../../../constants";


const OrderItemTemplate = (props) => {
    const { orderItem, materialDetails, stocDocs, poPunchDetails, dispatchNoteItems, dispatchNotes, invoiceDispatchMap, buyerInvoices, buyerInvoiceItems } = props

    const [expanded, setExpanded] = useState(false)
    const extensionRef = useRef(null)

    const userDetails = useSelector((state) => state.userDetails)
    
    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    useEffect(() => {
        if (expanded) {
          const scrollHeight = extensionRef.current.scrollHeight
          extensionRef.current.style.maxHeight = `${scrollHeight}px`
        } else {
          extensionRef.current.style.maxHeight = '0px'
        }
      }, [expanded])

    const toggleExpand = () => {
        setExpanded(!expanded)
    }

    let buyerName = getFullName(orderItem["buyerCompanyUsers"]?.firstName, orderItem["buyerCompanyUsers"]?.lastName)
    let kamName = getFullName(orderItem["users"]?.firstName, orderItem["users"]?.lastName)

    const getProductNameBody = (row) => {
        const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === row?.materialId)
        return (
            <div>{relatedMaterial?.companyProdName ? relatedMaterial?.companyProdName : relatedMaterial?.productName}  <span style={{ fontSize: "13px", color: "grey" }}>{relatedMaterial?.companyProdSpec ? relatedMaterial?.companyProdSpec : relatedMaterial?.productSpecification} </span> </div>
        )
    }

    const rowExpansionTemplate = (data) => {
        const updatedBuyerPOItems = data?.buyerPOItems?.map(eachBuyerPOItem => {
            let relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachBuyerPOItem?.materialId)
            const relatedDispatchNoteItems = dispatchNoteItems?.filter(eachDispatchNoteItem => eachDispatchNoteItem?.buyerPOItemId === eachBuyerPOItem?.buyerPOItemId)
            let relatedDispatchNotes = []
            let totalDispatchedQty = 0

            relatedDispatchNoteItems?.map(eachDispatchNoteItem => {
                const relatedDispatchNote = dispatchNotes?.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === eachDispatchNoteItem?.dispatchNoteId)
                if (relatedDispatchNote?.dispatchNoteId) {
                    relatedDispatchNotes.push(relatedDispatchNote)
                }
                totalDispatchedQty += eachDispatchNoteItem?.qty
            })
            let relatedInvoiceDispatchMap = []

            relatedDispatchNotes?.map(eachDispatchNote => {
                const relatedInvoiceDispatch = invoiceDispatchMap?.filter(eachInvoiceDispatchMap => eachInvoiceDispatchMap?.dispatchNoteId === eachDispatchNote?.dispatchNoteId)
                if (relatedInvoiceDispatch?.length > 0) {
                    relatedInvoiceDispatchMap = [...relatedInvoiceDispatchMap, ...relatedInvoiceDispatch]
                }
            })

            let relatedBuyerInvoices = []
            let totalInvoicedQty = 0
            relatedInvoiceDispatchMap?.map(eachInvoiceDispatchMap => {
                const relatedBuyerInvoice = buyerInvoices?.find(eachBuyerInvoice => eachBuyerInvoice?.buyerInvoiceId === eachInvoiceDispatchMap?.buyerInvoiceId)
                if (relatedBuyerInvoice?.buyerInvoiceId) {
                    relatedBuyerInvoices.push(relatedBuyerInvoice)
                }
                let relatedBuyerInvoiceItems = buyerInvoiceItems?.filter(eachBuyerInvoiceItem => eachBuyerInvoiceItem?.buyerReqItemId === eachBuyerPOItem?.buyerReqItemId)

                relatedBuyerInvoiceItems?.map(eachBuyerInvoiceItem => {
                    totalInvoicedQty += parseFloat(eachBuyerInvoiceItem?.qty)
                })
            })

            return {
                ...eachBuyerPOItem,
                ...relatedMaterial,
                totalInvoicedQty: totalInvoicedQty,
                totalDispatchedQty: totalDispatchedQty,
                pendingQty: parseFloat(eachBuyerPOItem?.bPOQty) - parseFloat(totalDispatchedQty),
                relatedDispatchNoteItems: relatedDispatchNoteItems,
                relatedBuyerInvoices: relatedBuyerInvoices
            }
        })

        const getSellerPODocNoBody = (row) => {
            return (
                <>
                    {
                        row?.relatedBuyerInvoices?.map(eachInvoice => (
                            <Link to={`/buyerInvoice/${eachInvoice?.buyerInvoiceId}`} style={{ textDecoration: "none", cursor: "pointer" }} target='_blank'><div>{eachInvoice?.docNo}</div></Link>
                        ))
                    }
                </>
            )
        }

        const getBuyerUnitPrice = (row) => {
            return numberConversion(row.bPOUnitPrice, numberLocale)
        }

        const getBPOQty = (row) => {
            return row.bPOQty
        }

        const getInvoicedQty = (row) => {
            const relatedStocDoc = stocDocs?.find(eachStocDoc => eachStocDoc?.docNo === row?.docNo && eachStocDoc?.materialId === row?.materialId)
            let invoicedQty = relatedStocDoc?.invoicedQty ? round(relatedStocDoc?.invoicedQty) : 0
            return invoicedQty > 0 ? invoicedQty : 0
        }

        const getInvoicePendingQty = (row) => {
            const relatedStocDoc = stocDocs?.find(eachStocDoc => eachStocDoc?.docNo === row?.docNo && eachStocDoc?.materialId === row?.materialId)
            let invoicedQty = relatedStocDoc?.invoicedQty ? round(relatedStocDoc?.invoicedQty) : 0

            const relatedPOPunch = poPunchDetails?.find(eachPOPunch => eachPOPunch?.buyerPOItemId === row?.buyerPOItemId)
            let availableQty = relatedPOPunch?.availableQty ? round(relatedPOPunch?.availableQty) : 0
            let bPOQty = relatedPOPunch?.bPOQty ? round(relatedPOPunch?.bPOQty) : 0
            let orderedQty = bPOQty - availableQty

            return orderedQty - invoicedQty > 0 ? round(orderedQty - invoicedQty) : 0
        }

        const getPendingQty = (row) => {
            const relatedPOPunch = poPunchDetails?.find(eachPOPunch => eachPOPunch?.buyerPOItemId === row?.buyerPOItemId)
            let availableQty = relatedPOPunch?.availableQty ? round(relatedPOPunch?.availableQty) : 0
            return availableQty
        }

        return (
            <div
                style={{ width: "100%", backgroundColor: "white" }} 
                ref={extensionRef}
                className={`flex flex-row extension ${expanded ? 'expanded' : ''}`}
            >
                <div className='flex flex-row' style={{ width: "100%", padding: "12px 30px 12px 30px" }} >
                    <div className='order-item-template-subtable' style={{ width: "100%" }}>
                        <DataTable value={updatedBuyerPOItems} scrollHeight="">
                            <Column field="companyProdName" header="Product Name" body={getProductNameBody} style={{ width: "20%" }}></Column>
                            <Column field="bPOUnitPrice" body={getBuyerUnitPrice} header="Unit price" style={{ width: "8%" }}></Column>
                            <Column field="POQuantity" body={getBPOQty} header="PO Qty" style={{ width: "8%" }}></Column>
                            <Column field="POQuantity" body={getPendingQty} header="Pending Qty" style={{ width: "8%" }}></Column>
                            <Column field="POQuantity" body={getInvoicedQty} header="Invoiced Qty" style={{ width: "8%" }}></Column>
                            <Column field="POQuantity" body={getInvoicePendingQty} header="Inprocess Qty" style={{ width: "8%" }}></Column>
                            <Column field="" header="Invoices" body={getSellerPODocNoBody} style={{ width: "10%" }}></Column>
                        </DataTable>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="flex flex-column purchase-order-template" style={{ width: "100%", marginBottom: "14px" }}>
            <div className="flex purchase-order-template-header" style={{ width: "100%", padding: "14px 18px", paddingBottom: "0px", backgroundColor: "rgb(234 239 239 / 41%)", height: "60px" }}>
                <div className="flex flex-column" style={{ width: "15%" }}>
                    <span style={{ fontSize: "13px" }}>ORDER DATE</span>
                    <span className='mt-1 font-bold'>{moment(orderItem.createdAt).format(DATE_FORMAT)}</span>
                </div>
                <div className="flex flex-column" style={{ width: "16%" }}>
                    <span style={{ fontSize: "13px" }}>PLACED BY</span>
                    <span className='mt-1 font-bold'>{buyerName}</span>
                </div>
                <div className="flex flex-column" style={{ width: "12%" }}>
                    <span style={{ fontSize: "13px" }}>TOTAL</span>
                    <span className='mt-1 font-bold'>&#8377; {numberConversion(parseFloat(orderItem.totalPOAmount), numberLocale)}</span>
                </div>
                <div className="flex flex-column" style={{ width: "19%" }}>
                    <span style={{ fontSize: "13px" }}>KAM NAME</span>
                    <span className='mt-1 font-bold'>{kamName}</span>
                </div>
                <div className="flex flex-column align-items-end" style={{ width: "38%" }}>
                    <span className='font-bold' style={{ color: "rgb(18 124 103)" }}>{orderItem.clientPONum}</span>
                    <a className='mt-1' style={{ cursor: "pointer" }} onClick={toggleExpand} >
                        {
                            expanded ? 
                                <> Hide Details <i className="pi pi-arrow-circle-up" style={{ color: 'grey', fontWeight: "bold", marginTop: "1px" }}></i> </> 
                                : 
                                <> View Details <i className="pi pi-arrow-circle-down" style={{ color: 'grey', fontWeight: "bold", marginTop: "1px" }}></i> </> 
                        }
                    </a>
                </div>
            </div>
            <div className="flex purchase-order-template-body" style={{ width: "100%", borderTopWidth: `${expanded ? "0px" : "0px" }` }}>
                {rowExpansionTemplate(orderItem)}
            </div>
            <div className="flex purchase-order-template-footer" style={{ width: "100%", backgroundColor: "rgb(240 242 242 / 75%)", height: "8px" }}>
            </div>
        </div>
    )
}

export default OrderItemTemplate;